import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.API_BASE_URL}/admin`;

class ClaimsService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getClaims() {
    try {
      const response = await axios.get(
        `${BASE_URL}/policy/get/all/claimed`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason ||
          "Claims fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting claims",
      };
    }
  }

  async getClaimsByPolicy(policySlug) {
    try {
      const response = await axios.get(
        `${BASE_URL}/policy/show/claim/${policySlug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Policy claims fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting policy claims",
      };
    }
  }

  async getApprovedClaims() {
    try {
      const response = await axios.get(
        `${BASE_URL}/policy/get/claimed`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Approved claims fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting approved claims",
      };
    }
  }

  async getRejectedClaims() {
    try {
      const response = await axios.get(
        `${BASE_URL}/policy/get/rejected`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Rejected claims fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting rejected claims",
      };
    }
  }

  async updateClaimStatus(claimSlug, status, rejectReason = null) {
    try {
      const payload = { status };
      if (rejectReason) {
        payload.reject_reason = rejectReason;
      }
      const response = await axios.put(
        `${BASE_URL}/claim/${claimSlug}/status`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        message: response.data?.data?.reason || "Claim status updated successfully",
        data: response.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.data?.reason || "An error occurred while updating claim status",
        data: null,
      };
    }
  }
}

const claimsService = new ClaimsService();
export default claimsService;
